import {DMODELS_EMPTY, useDmodelMutations} from "../../api/dmodelsapi";
import React, {useCallback} from "react";
import {BMODELS_EMPTY} from "../../api/bmodelsapi";
import {useForm} from "../../utilities/formutilities";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, Row} from "react-bootstrap";
import {Section} from "../grouping/Section";
import {FormControlCustom} from "../controls/FormControls";
import {Bounce, toast} from "react-toastify";
import {pdf, PDFViewer} from "@react-pdf/renderer";
import {ModelDPdf} from "../formpdf/ModelDPdf";
import {useFileMutations} from "../../api/fileapi";
import {useEmailMutations} from "../../api/emailapi";
import {minioBaseUrl} from "../../data/defaultConfig";
import {LabelWithInput} from "../grouping/LabelWithInput";

export function DmodelForm(props) {
    const {itemEditing, onItemEditingChanged, onOpenChanged} = props;
    const {createDmodel, editDmodel} = useDmodelMutations();
    const {uploadFile} = useFileMutations();
    const {createFormEmail} = useEmailMutations();
    const initialObjectInintializer = useCallback(() => itemEditing ? itemEditing : DMODELS_EMPTY, [])
    const {onChange, tempObject} = useForm(initialObjectInintializer);
    const notify = (message, type) => {
        toast(<div>
            <Row className={"g-0"}>
                <Col xs={12} className={"mb-3"}>
                    {message}
                </Col>
            </Row>
        </div>, {
            position: "top-right",
            autoClose: 5000,
            type: type,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
        });
    }

    async function handleCreate(event) {
        event.preventDefault();
        console.log(tempObject)
        const response = await createDmodel({
            ...tempObject,
            datumOpstelling: (new Date().toISOString())
        });

        if (response) {
            notify('Model D is verzonden.', 'success');
            const blob = await pdf(ModelDPdf({modelDTempObject: tempObject})).toBlob();
            const pdfFile = new File([blob], `modelD-${new Date().toISOString().substring(0, 10)}${new Date().getMinutes()}${new Date().getMilliseconds()}.pdf`);
            const uploadFileResult = await uploadFile({file: pdfFile});
            if (uploadFileResult) {
                const newEmail = {
                    title: "VBFlw, Nieuw Model D formulier ingevuld",
                    emailto: '',
                    emailfrom: "administratie@vbflw.be",
                    description: `
                    <p>Automatisch bericht van de VBFlw website:</p>
                    <p>Er is een Model D formulier ingevuld.</p>
                    <a href="${minioBaseUrl + uploadFileResult.url}">Click hier voor de pdf te downloaden</a>
                    `,
                    attachment: uploadFileResult.id
                };
                const emailResult = await createFormEmail(newEmail);
                if (emailResult) window.location.reload();
            }
        }
        if (!response) notify('Fout bij het verzenden. Probeer het later nog eens.', 'error');
    }

    async function handleEdit(e) {
        const result = await editDmodel(tempObject);
        if (result) {
            onItemEditingChanged(undefined);
            onOpenChanged(false);
        }
    }

    const formComplete =
        tempObject.provincie &&
        tempObject.provincieNr &&
        tempObject.naamVoorzitter &&
        tempObject.voornaamVoorzitter &&
        tempObject.straatVoorzitter &&
        tempObject.nrVoorzitter &&
        tempObject.postcodeVoorzitter &&
        tempObject.gemeenteVoorzitter &&
        (tempObject.telVoorzitter || tempObject.gsmVoorzitter) &&
        tempObject.emailVoorzitter &&
        tempObject.naamSecretaris &&
        tempObject.voornaamSecretaris &&
        tempObject.straatSecretaris &&
        tempObject.nrSecretaris &&
        tempObject.postcodeSecretaris &&
        tempObject.gemeenteSecretaris &&
        tempObject.gemeenteSecretaris &&
        (tempObject.telSecretaris || tempObject.gsmSecretaris) &&
        tempObject.emailSecretaris &&
        tempObject.naamPenning &&
        tempObject.voornaamPenning &&
        tempObject.straatPenning &&
        tempObject.nrPenning &&
        tempObject.postcodePenning &&
        tempObject.gemeentePenning &&
        (tempObject.telPenning || tempObject.gsmPenning) &&
        tempObject.emailPenning;

    return <Form>
        <Section>
            <Section>

                <Col xs={6}>
                    <FormControlCustom title={'Provincie*'} value={tempObject.provincie} filled={tempObject.provincie}
                                       onChange={e => onChange(e, 'provincie')}/>
                </Col>
                <Col xs={6}>
                    <FormControlCustom title={'Provincie nr*'} value={tempObject.provincieNr}
                                       filled={tempObject.provincieNr}
                                       onChange={e => onChange(e, 'provincieNr')}/>
                </Col>
            </Section>
            <hr/>
            <Section>
                <Col xs={2}>
                    Voorzitter
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={6}>
                            <FormControlCustom title={'Naam*'} value={tempObject.naamVoorzitter}
                                               filled={tempObject.naamVoorzitter}
                                               onChange={e => onChange(e, 'naamVoorzitter')}/>
                        </Col>
                        <Col xs={6}>
                            <FormControlCustom title={'Voornaam*'} value={tempObject.voornaamVoorzitter}
                                               filled={tempObject.voornaamVoorzitter}
                                               onChange={e => onChange(e, 'voornaamVoorzitter')}/>
                        </Col>
                        <Col xs={8}>
                            <FormControlCustom title={'Straat*'} value={tempObject.straatVoorzitter}
                                               filled={tempObject.straatVoorzitter}
                                               onChange={e => onChange(e, 'straatVoorzitter')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Nr*'} value={tempObject.nrVoorzitter}
                                               filled={tempObject.nrVoorzitter}
                                               onChange={e => onChange(e, 'nrVoorzitter')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Postcode*'} v={tempObject.postcodeVoorzitter}
                                               filled={tempObject.postcodeVoorzitter}
                                               onChange={e => onChange(e, 'postcodeVoorzitter')}/>
                        </Col>
                        <Col xs={8}>
                            <FormControlCustom title={'Gemeente*'} value={tempObject.gemeenteVoorzitter}
                                               filled={tempObject.gemeenteVoorzitter}
                                               onChange={e => onChange(e, 'gemeenteVoorzitter')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Tel*'} value={tempObject.telVoorzitter}
                                               filled={tempObject.telVoorzitter}
                                               onChange={e => onChange(e, 'telVoorzitter')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Gsm*'} value={tempObject.gsmVoorzitter}
                                               filled={tempObject.gsmVoorzitter}
                                               onChange={e => onChange(e, 'gsmVoorzitter')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Fax'}
                                               onChange={e => onChange(e, 'faxVoorzitter')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Email*'} value={tempObject.emailVoorzitter}
                                               filled={tempObject.emailVoorzitter}
                                               onChange={e => onChange(e, 'emailVoorzitter')}/>
                        </Col>
                    </Section>
                </Col>
            </Section>

            <hr/>
            <Section>
                <Col xs={2}>
                    Secretaris
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={6}>
                            <FormControlCustom title={'Naam*'} value={tempObject.naamSecretaris}
                                               filled={tempObject.naamSecretaris}
                                               onChange={e => onChange(e, 'naamSecretaris')}/>
                        </Col>
                        <Col xs={6}>
                            <FormControlCustom title={'Voornaam*'} value={tempObject.voornaamSecretaris}
                                               filled={tempObject.voornaamSecretaris}
                                               onChange={e => onChange(e, 'voornaamSecretaris')}/>
                        </Col>
                        <Col xs={8}>
                            <FormControlCustom title={'Straat*'} value={tempObject.straatSecretaris}
                                               filled={tempObject.straatSecretaris}
                                               onChange={e => onChange(e, 'straatSecretaris')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Nr*'} value={tempObject.nrSecretaris}
                                               filled={tempObject.nrSecretaris}
                                               onChange={e => onChange(e, 'nrSecretaris')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Postcode*'} value={tempObject.postcodeSecretaris}
                                               filled={tempObject.postcodeSecretaris}
                                               onChange={e => onChange(e, 'postcodeSecretaris')}/>
                        </Col>
                        <Col xs={8}>
                            <FormControlCustom title={'Gemeente*'} value={tempObject.gemeenteSecretaris}
                                               filled={tempObject.gemeenteSecretaris}
                                               onChange={e => onChange(e, 'gemeenteSecretaris')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Tel*'} value={tempObject.telSecretaris}
                                               filled={tempObject.telSecretaris}
                                               onChange={e => onChange(e, 'telSecretaris')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Gsm*'} value={tempObject.gsmSecretaris}
                                               filled={tempObject.gsmSecretaris}
                                               onChange={e => onChange(e, 'gsmSecretaris')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Fax'} value={tempObject.faxSecretaris}
                                               onChange={e => onChange(e, 'faxSecretaris')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Email*'} value={tempObject.emailSecretaris}
                                               filled={tempObject.emailSecretaris}
                                               onChange={e => onChange(e, 'emailSecretaris')}/>
                        </Col>
                    </Section>
                </Col>
            </Section>
            <hr/>
            <Section>
                <Col xs={2}>
                    Penningsmeester
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={6}>
                            <FormControlCustom title={'Naam*'} value={tempObject.naamPenning}
                                               filled={tempObject.naamPenning}
                                               onChange={e => onChange(e, 'naamPenning')}/>
                        </Col>
                        <Col xs={6}>
                            <FormControlCustom title={'Voornaam*'} value={tempObject.voornaamPenning}
                                               filled={tempObject.voornaamPenning}
                                               onChange={e => onChange(e, 'voornaamPenning')}/>
                        </Col>
                        <Col xs={8}>
                            <FormControlCustom title={'Straat*'} value={tempObject.straatPenning}
                                               filled={tempObject.straatPenning}
                                               onChange={e => onChange(e, 'straatPenning')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Nr*'} value={tempObject.nrPenning} filled={tempObject.nrPenning}
                                               onChange={e => onChange(e, 'nrPenning')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Postcode*'} value={tempObject.postcodePenning}
                                               filled={tempObject.postcodePenning}
                                               onChange={e => onChange(e, 'postcodePenning')}/>
                        </Col>
                        <Col xs={8}>
                            <FormControlCustom title={'Gemeente*'} value={tempObject.gemeentePenning}
                                               filled={tempObject.gemeentePenning}
                                               onChange={e => onChange(e, 'gemeentePenning')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Tel*'} value={tempObject.telPenning}
                                               filled={tempObject.telPenning}
                                               onChange={e => onChange(e, 'telPenning')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Gsm*'} value={tempObject.gsmPenning}
                                               filled={tempObject.gsmPenning}
                                               onChange={e => onChange(e, 'gsmPenning')}/>
                        </Col>
                        <Col xs={4}>
                            <FormControlCustom title={'Fax'} value={tempObject.faxPenning}
                                               onChange={e => onChange(e, 'faxPenning')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Email*'} value={tempObject.emailPenning}
                                               filled={tempObject.emailPenning}
                                               onChange={e => onChange(e, 'emailPenning')}/>
                        </Col>
                    </Section>
                </Col>
            </Section>
            <hr/>

            <Section>
                <Col xs={2}>
                    Raadsleden
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={6}>
                            <FormLabel>Naam</FormLabel>
                            <FormControl value={tempObject.naamRaadslid1} onChange={e => onChange(e, 'naamRaadslid1')}/>
                        </Col>
                        <Col xs={6}>
                            <FormLabel>Voornaam</FormLabel>
                            <FormControl value={tempObject.voornaamRaadslid1}
                                         onChange={e => onChange(e, 'voornaamRaadslid1')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Straat</FormLabel>
                            <FormControl value={tempObject.straatRaadslid1}
                                         onChange={e => onChange(e, 'straatRaadslid1')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Nr</FormLabel>
                            <FormControl value={tempObject.nrRaadslid1} onChange={e => onChange(e, 'nrRaadslid1')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Postcode</FormLabel>
                            <FormControl value={tempObject.postcodeRaadslid1}
                                         onChange={e => onChange(e, 'postcodeRaadslid1')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Gemeente</FormLabel>
                            <FormControl value={tempObject.gemeenteRaadslid1}
                                         onChange={e => onChange(e, 'gemeenteRaadslid1')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Tel</FormLabel>
                            <FormControl value={tempObject.telRaadslid1} onChange={e => onChange(e, 'telRaadslid1')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Gsm</FormLabel>
                            <FormControl value={tempObject.gsmRaadslid1} onChange={e => onChange(e, 'gsmRaadslid1')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Fax</FormLabel>
                            <FormControl value={tempObject.faxRaadslid1} onChange={e => onChange(e, 'faxRaadslid1')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Email</FormLabel>
                            <FormControl value={tempObject.faxRaadslid1} onChange={e => onChange(e, 'emailRaadslid1')}/>
                        </Col>
                    </Section>
                    <hr/>
                    <Section>
                        <Col xs={6}>
                            <FormLabel>Naam</FormLabel>
                            <FormControl value={tempObject.naamRaadslid2} onChange={e => onChange(e, 'naamRaadslid2')}/>
                        </Col>
                        <Col xs={6}>
                            <FormLabel>Voornaam</FormLabel>
                            <FormControl value={tempObject.voornaamRaadslid2}
                                         onChange={e => onChange(e, 'voornaamRaadslid2')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Straat</FormLabel>
                            <FormControl value={tempObject.straatRaadslid2}
                                         onChange={e => onChange(e, 'straatRaadslid2')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Nr</FormLabel>
                            <FormControl value={tempObject.nrRaadslid2} onChange={e => onChange(e, 'nrRaadslid2')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Postcode</FormLabel>
                            <FormControl value={tempObject.postcodeRaadslid2}
                                         onChange={e => onChange(e, 'postcodeRaadslid2')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Gemeente</FormLabel>
                            <FormControl value={tempObject.gemeenteRaadslid2}
                                         onChange={e => onChange(e, 'gemeenteRaadslid2')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Tel</FormLabel>
                            <FormControl value={tempObject.telRaadslid2} onChange={e => onChange(e, 'telRaadslid2')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Gsm</FormLabel>
                            <FormControl value={tempObject.gsmRaadslid2} onChange={e => onChange(e, 'gsmRaadslid2')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Fax</FormLabel>
                            <FormControl value={tempObject.faxRaadslid2} onChange={e => onChange(e, 'faxRaadslid2')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Email</FormLabel>
                            <FormControl value={tempObject.emailRaadslid2}
                                         onChange={e => onChange(e, 'emailRaadslid2')}/>
                        </Col>
                    </Section>
                    <hr/>
                    <Section>
                        <Col xs={6}>
                            <FormLabel>Naam</FormLabel>
                            <FormControl value={tempObject.naamRaadslid3} onChange={e => onChange(e, 'naamRaadslid3')}/>
                        </Col>
                        <Col xs={6}>
                            <FormLabel>Voornaam</FormLabel>
                            <FormControl value={tempObject.voornaamRaadslid3}
                                         onChange={e => onChange(e, 'voornaamRaadslid3')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Straat</FormLabel>
                            <FormControl value={tempObject.straatRaadslid3}
                                         onChange={e => onChange(e, 'straatRaadslid3')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Nr</FormLabel>
                            <FormControl value={tempObject.nrRaadslid3} onChange={e => onChange(e, 'nrRaadslid3')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Postcode</FormLabel>
                            <FormControl value={tempObject.postcodeRaadslid3}
                                         onChange={e => onChange(e, 'postcodeRaadslid3')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Gemeente</FormLabel>
                            <FormControl value={tempObject.gemeenteRaadslid3}
                                         onChange={e => onChange(e, 'gemeenteRaadslid3')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Tel</FormLabel>
                            <FormControl value={tempObject.telRaadslid3} onChange={e => onChange(e, 'telRaadslid3')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Gsm</FormLabel>
                            <FormControl value={tempObject.gsmRaadslid3} onChange={e => onChange(e, 'gsmRaadslid3')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Fax</FormLabel>
                            <FormControl value={tempObject.faxRaadslid3} onChange={e => onChange(e, 'faxRaadslid3')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Email</FormLabel>
                            <FormControl value={tempObject.emailRaadslid3}
                                         onChange={e => onChange(e, 'emailRaadslid3')}/>
                        </Col>
                    </Section>
                    <hr/>
                    <Section>
                        <Col xs={6}>
                            <FormLabel>Naam</FormLabel>
                            <FormControl value={tempObject.naamRaadslid4} onChange={e => onChange(e, 'naamRaadslid4')}/>
                        </Col>
                        <Col xs={6}>
                            <FormLabel>Voornaam</FormLabel>
                            <FormControl value={tempObject.voornaamRaadslid4}
                                         onChange={e => onChange(e, 'voornaamRaadslid4')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Straat</FormLabel>
                            <FormControl value={tempObject.straatRaadslid4}
                                         onChange={e => onChange(e, 'straatRaadslid4')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Nr</FormLabel>
                            <FormControl value={tempObject.nrRaadslid4} onChange={e => onChange(e, 'nrRaadslid4')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Postcode</FormLabel>
                            <FormControl value={tempObject.postcodeRaadslid4}
                                         onChange={e => onChange(e, 'postcodeRaadslid4')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Gemeente</FormLabel>
                            <FormControl value={tempObject.gemeenteRaadslid4}
                                         onChange={e => onChange(e, 'gemeenteRaadslid4')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Tel</FormLabel>
                            <FormControl value={tempObject.telRaadslid4} onChange={e => onChange(e, 'telRaadslid4')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Gsm</FormLabel>
                            <FormControl value={tempObject.gsmRaadslid4} onChange={e => onChange(e, 'gsmRaadslid4')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Fax</FormLabel>
                            <FormControl value={tempObject.faxRaadslid4} onChange={e => onChange(e, 'faxRaadslid4')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Email</FormLabel>
                            <FormControl value={tempObject.emailRaadslid4}
                                         onChange={e => onChange(e, 'emailRaadslid4')}/>
                        </Col>
                    </Section>
                    <hr/>
                    <Section>
                        <Col xs={6}>
                            <FormLabel>Naam</FormLabel>
                            <FormControl value={tempObject.naamRaadslid5} onChange={e => onChange(e, 'naamRaadslid5')}/>
                        </Col>
                        <Col xs={6}>
                            <FormLabel>Voornaam</FormLabel>
                            <FormControl value={tempObject.voornaamRaadslid5}
                                         onChange={e => onChange(e, 'voornaamRaadslid5')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Straat</FormLabel>
                            <FormControl value={tempObject.straatRaadslid5}
                                         onChange={e => onChange(e, 'straatRaadslid5')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Nr</FormLabel>
                            <FormControl value={tempObject.nrRaadslid5} onChange={e => onChange(e, 'nrRaadslid5')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Postcode</FormLabel>
                            <FormControl value={tempObject.postcodeRaadslid5}
                                         onChange={e => onChange(e, 'postcodeRaadslid5')}/>
                        </Col>
                        <Col xs={8}>
                            <FormLabel>Gemeente</FormLabel>
                            <FormControl value={tempObject.gemeenteRaadslid5}
                                         onChange={e => onChange(e, 'gemeenteRaadslid5')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Tel</FormLabel>
                            <FormControl value={tempObject.telRaadslid5} onChange={e => onChange(e, 'telRaadslid5')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Gsm</FormLabel>
                            <FormControl value={tempObject.gsmRaadslid5} onChange={e => onChange(e, 'gsmRaadslid5')}/>
                        </Col>
                        <Col xs={4}>
                            <FormLabel>Fax</FormLabel>
                            <FormControl value={tempObject.faxRaadslid5} onChange={e => onChange(e, 'faxRaadslid5')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Email</FormLabel>
                            <FormControl value={tempObject.emailRaadslid5}
                                         onChange={e => onChange(e, 'emailRaadslid5')}/>
                        </Col>
                    </Section>
                </Col>
                {itemEditing ? <Col xs={6} className={'p-1'}>
                    <Section>
                        <Col xs={12}>
                            <FormLabel htmlFor={'vzwjn'}>Verwerkt? </FormLabel>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={'ja'}> <FormCheck id={'verwerktja'} defaultChecked={tempObject.verwerkt}
                                                                     name={'verwerkt'} value={"true"} type={'radio'}
                                                                     onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>

                        </Col>
                        <Col xs={'auto me-2'}>
                            <LabelWithInput title={'nee'}> <FormCheck id={'verwerktnee'}
                                                                      defaultChecked={!tempObject.verwerkt}
                                                                      name={'verwerkt'}
                                                                      value={"false"} type={'radio'}
                                                                      onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>
                        </Col>
                    </Section>
                </Col> : ''}
            </Section>


            <Col xs={12} className={'text-end mt-2'}>
                <Button disabled={!formComplete}
                        onClick={e => itemEditing ? handleEdit(e) : handleCreate(e)}>{!formComplete ? 'Nog niet alle verplichte * velden zijn ingevuld!' : 'Submit'}</Button>
            </Col>
        </Section>
    </Form>
}